import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store, { history } from './redux/store';
import { HistoryRouter } from 'redux-first-history/rr6'
import AppRoutes from './routes/AppRoutes'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <HistoryRouter history={history}>
            <AppRoutes />
        </HistoryRouter>
    </Provider>
);
reportWebVitals();
